<template>
  <div class="drawer-container">
    <div>
      <h3 class="drawer-title">系统布局配置</h3>

      <div class="drawer-item">
        <span>主题色</span>
        <theme-picker
          style="float: right; height: 26px; margin: -3px 8px 0 0"
        />
      </div>

      <div class="drawer-item">
        <span>标签式导航</span>
        <el-switch v-model="tagsView" class="drawer-switch" />
      </div>

      <div class="drawer-item">
        <span>固定顶部导航栏</span>
        <el-switch v-model="isFixHeader" class="drawer-switch" />
      </div>

      <div class="drawer-item">
        <span>侧边栏Logo</span>
        <el-switch v-model="isShowSidebarLogo" class="drawer-switch" />
      </div>
    </div>
  </div>
</template>

<script>
import ThemePicker from "@/components/ThemePicker";

export default {
  components: { ThemePicker },
  data() {
    return {};
  },
  computed: {
    isFixHeader: {
      get() {
        return this.$store.state.settings.isFixHeader;
      },
      set(val) {
        this.$store.dispatch("settings/changeSetting", {
          key: "isFixHeader",
          value: val,
        });
      },
    },
    tagsView: {
      get() {
        return this.$store.state.settings.tagsView;
      },
      set(val) {
        this.$store.dispatch("settings/changeSetting", {
          key: "tagsView",
          value: val,
        });
      },
    },
    isShowSidebarLogo: {
      get() {
        return this.$store.state.settings.isShowSidebarLogo;
      },
      set(val) {
        this.$store.dispatch("settings/changeSetting", {
          key: "isShowSidebarLogo",
          value: val,
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer-container {
  padding: 24px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;

  .drawer-title {
    margin-bottom: 12px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    line-height: 22px;
  }

  .drawer-item {
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    padding: 12px 0;
  }

  .drawer-switch {
    float: right;
  }
}
</style>
